export const Autocomplete = `
    const defaultValue = '3';
        
    const options: IOptions[] = [
        {
            "key": 1,
            "label": "Leanne Graham",
            "value": "1"
        },
        {
            "key": 2,
            "label": "Ervin Howell",
            "value": "2"
        },
        {
            "key": 3,
            "label": "Clementine Bauch",
            "value": "3"
        },
        {
            "key": 4,
            "label": "Patricia Lebsack",
            "value": "4"
        },
        {
            "key": 5,
            "label": "Chelsey Dietrich",
            "value": "5"
        },
        {
            "key": 6,
            "label": "Mrs. Dennis Schulist",
            "value": "6"
        },
        {
            "key": 7,
            "label": "Kurtis Weissnat",
            "value": "7"
        },
        {
            "key": 8,
            "label": "Nicholas Runolfsdottir V",
            "value": "8"
        },
        {
            "key": 9,
            "label": "Glenna Reichert",
            "value": "9"
        },
        {
            "key": 10,
            "label": "Clementina DuBuque",
            "value": "10"
        }];

    const onChange = (searchText: any) => {
        console.log(searchText)
    }

    const onSelect = (selectedOption: IOptions) => {
        console.log(selectedOption)
    }
    
    <div>
        <Autocomplete 
            label={'Autocomplete'}
            options={options}
            defaultValue={defaultValue}
            onChange={onChange}
            onSelect={onSelect}
        />
        <Autocomplete 
            label={'Disabled Autocomplete'}
            options={options}
            defaultValue={defaultValue}
            onChange={onChange}
            onSelect={onSelect}
            disabled={true}
        />
        <Autocomplete
            label={'Autocomplete with error'}
            options={options}
            defaultValue={defaultValue}
            onChange={onChange}
            onSelect={onSelect}
            isInvalid={true}
            isInvalidText={'Please enter a valid name'}
        />
        <Autocomplete
            label={'Autocomplete'}
            options={options}
            defaultValue={defaultValue}
            onChange={onChange}
            onSelect={onSelect}
            size='lg'
        />
    </div>
`
